import { ClearSelectionIconProps, InputRightIconProps } from './select.types';
import { addStyles, CheckMark, ChevronDownIcon, MagnifyingGlassIcon, MenuItem, XmarkIcon } from '../../index';

const styles = {
  inputRight: {
    base: 'absolute top-0.5 right-0 flex items-center justify-center',
    size: {
      medium: 'size-[calc(2rem-2px)]',
      large: 'size-[calc(2.75rem-2px)]',
    },
    clear: {
      medium: 'mr-[calc(2rem-2px)]',
      large: 'mr-[calc(2.75rem-2px)]',
    },
    dropdown: 'mr-px',
    hoverBg: 'hover:bg-gray-100 rounded-lg',
    iconBase: 'size-5 self-center',
    search: 'mr-1',
    searchIcon: 'size-7.5 p-2',
  },
  menuItem: {
    selectable: 'cursor-pointer truncate',
    notSelectable: 'cursor-not-allowed p-2 text-gray-600 text-sm',
  },
  checkMarkIcon: {
    base: 'h-4 inline w-4.5 mr-2',
    unselected: 'fill-transparent',
    selected: 'fill-gray-900',
  },
};

const MenuOpenIcon = (props: InputRightIconProps) => (
  <div
    className={addStyles([
      styles.inputRight.base,
      styles.inputRight.size[props.size],
      styles.inputRight.dropdown,
      styles.inputRight.hoverBg,
    ])}
    onClick={() => props.inputRef.current?.focus()}
    id={`Toggle-${props.inputId}`}
    data-testid={`Toggle-${props.inputId}`}
  >
    <ChevronDownIcon className={styles.inputRight.iconBase} />
  </div>
);

const SearchIcon = (props: InputRightIconProps) => (
  <div
    className={addStyles([styles.inputRight.base, styles.inputRight.size[props.size], styles.inputRight.search])}
    id={`Search-${props.inputId}`}
  >
    <MagnifyingGlassIcon className={styles.inputRight.searchIcon} />
  </div>
);

const ClearSelectionIcon = (props: ClearSelectionIconProps) => {
  const { allowClear, inputHasSelection, inputId, onClearSelection, size } = props;

  return allowClear && inputHasSelection ? (
    <div
      className={addStyles([
        styles.inputRight.base,
        styles.inputRight.size[size],
        styles.inputRight.clear[size],
        styles.inputRight.hoverBg,
      ])}
      id={`Clear-${inputId}`}
      onClick={(e) => onClearSelection?.(e)}
    >
      <XmarkIcon className={styles.inputRight.iconBase} />
    </div>
  ) : (
    <></>
  );
};

const InputRightIcon = (props: InputRightIconProps) => (props.menuOpen ? SearchIcon(props) : MenuOpenIcon(props));

export const defaultMenuItemRenderer = <T extends MenuItem>(item: T, isSelected: boolean) => {
  return (
    <div className={styles.menuItem.selectable}>
      {
        <CheckMark
          className={addStyles([
            styles.checkMarkIcon.base,
            isSelected ? styles.checkMarkIcon.selected : styles.checkMarkIcon.unselected,
          ])}
        />
      }
      <span>{item.label || item.value}</span>
    </div>
  );
};

export const defaultNoMatchMenuItemRenderer = () => {
  return (
    <div className={styles.menuItem.notSelectable} role={'note'}>
      <span>No results found</span>
    </div>
  );
};

export { ClearSelectionIcon, InputRightIcon };
